import { tabItemNames } from '@/components/Service/TabContainer/tabItems';
import { Card } from '../card';
import styles from './style.module.scss';
import React, { ReactNode } from 'react';
import { useRouter } from 'next/router';

export interface tabItem {
  id: string;
  href?: string;
  component: ReactNode;
}

export interface tabProps {
  classNames?: string;
  tabItems: tabItem[];
  activeClassNames: string;
  setActiveTab: Function;
  activeTab: string;
  cardClassNames?: string;
}

export const Tab = (props: tabProps) => {
  const { cardClassNames, classNames, tabItems, activeClassNames, setActiveTab, activeTab } = props;
  const router = useRouter();
  const handleItemClick = (name: string, href?: string) => {
    if (href) {
      router.push(href);
      return;
    } else if (name === tabItemNames.MyDevices) {
      router.replace(
        {
          query: { showMyDevices: true },
        },
        undefined,
        {
          shallow: true,
        },
      );
    }
    setActiveTab(name);
  };

  const listClassNames = `overflow-x-auto w-full flex items-center gap-s5 justify-start pl-6 md:pl-0 md:justify-center md:gap-s30 pt-[0.6rem] md:pt-0 ${styles.scrollbar} ${styles.mainTab}`;

  const itemsContainerClass = `mt-2 md:h-25 md:mt-4 ${styles.card} ${classNames} ${cardClassNames}`;
  return (
    <Card classNames={itemsContainerClass} key={`key_${tabItems.length}`}>
      <ul className={listClassNames}>
        {tabItems.map((item, index) => {
          const activeId =
            activeTab === item.id ? 'active-' + index + '-' + item.id : index + '-' + item.id;
          return (
            <li
              data-testid={activeId}
              id={item.id}
              className={activeTab === item.id ? activeClassNames : ``}
              onClick={() => handleItemClick(item.id, item?.href)}
              key={index + item.id}
            >
              {item.component}
            </li>
          );
        })}
      </ul>
    </Card>
  );
};
